export const DASHBOARD_PATHS = {
  root: "/" as const,
} as const;

export const COMPANIES_PATHS = {
  companies: "/companies" as const,
  detail: (id: string) => {
    return `${COMPANIES_PATHS.companies}/${id}` as const;
  },
} as const;

export const NOTIFICATION_PATHS = {
  root: `/notifications` as const,
} as const;

export const ACCOUNT_PATHS = {
  root: `/account` as const,
  notifications: () => `${ACCOUNT_PATHS.root}/notifications` as const,
  skills: () => `${ACCOUNT_PATHS.root}/skills` as const,
} as const;

export const CONTENT_LIBRARY_PATHS = {
  root: `/content-library` as const,
  detail: (id: string) => `${CONTENT_LIBRARY_PATHS.root}/${id}` as const,
  tractionAcademics: () => `${CONTENT_LIBRARY_PATHS.root}/1569` as const,
} as const;

export const EVENTS_PATHS = {
  root: `/events` as const,
  detail: (id: string) => `${EVENTS_PATHS.root}/${id}` as const,
  type: (type: string) => `${EVENTS_PATHS.root}/type/${type}` as const,
} as const;

export const INTERVIEW_PATHS = {
  root: "/interviews" as const,
  detail: (id: string) => `${INTERVIEW_PATHS.root}/${id}` as const,
} as const;

export const SURVEYS_PATHS = {
  root: "/surveys" as const,
  reflections: "/interview-reflections" as const,
  detail: (id: string) => `${SURVEYS_PATHS.root}/${id}` as const,
} as const;

export const JOB_PATHS = {
  root: `/jobs` as const,
  detail: (id: string) => `${JOB_PATHS.root}/${id}` as const,
  gamePlan: () => `${JOB_PATHS.root}/game-plan` as const,
  gamePlanDetail: (id: string) => `${JOB_PATHS.gamePlan()}/${id}` as const,
} as const;

export const ASSIGNMENT_PATHS = {
  root: `/assignments` as const,
  detail: (id: string) => `${ASSIGNMENT_PATHS.root}/${id}` as const,
} as const;
